import type { IValidatedResponse } from '../../httpClient';
import { deleteRequest } from '../../httpClient';
import type { IDeleteSocialChannelV1Request } from './delete-social-channel-v1-request';
import type { IDeleteSocialChannelV1Response } from './delete-social-channel-v1-response';
import { deleteSocialChannelV1ResponseSchema } from './delete-social-channel-v1-response';

export async function deleteSocialChannelV1Api({
  channelId,
}: IDeleteSocialChannelV1Request): Promise<IValidatedResponse<IDeleteSocialChannelV1Response>> {
  return deleteRequest<IDeleteSocialChannelV1Response>({
    path: `/sys/social/v1/channels/${channelId}`,
    schema: deleteSocialChannelV1ResponseSchema,
  });
}
